import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=08702106&scoped=true&"
import script from "./ItemEditor.vue?vue&type=script&lang=js&"
export * from "./ItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&id=08702106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08702106",
  null
  
)

export default component.exports